import React, { useState } from "react";
import { useSelector } from "react-redux";
import "./CheckoutCregis.scss";
import CountDown from "../../comp/CountDown";
import CopyButton from "../../comp/CopyButton";
import Warning from "../../comp/Warning";
import { useTranslation, Trans } from "react-i18next";

function CheckoutCregis() {
  const { t } = useTranslation();
  const { payData } = useSelector((state) => state);
  const [isQrExpired, setIsQrExpired] = useState(false);
  return (
    <div className="checkoutCregis">
      <div className="checkoutCregis__container">
        <div className="checkoutCregis__container__qr">
          <p>{`${payData.crypto_amount} ${payData.crypto_currency}`}</p>
          <div className="checkoutCregis__container__qr__container">
            <img src={payData.qr_img} alt="" style={{ filter: isQrExpired ? "blur(3px)" : "blur(0)" }} />
            {isQrExpired && (
              <p className="checkoutCregis__container__qr__container__exp">{t("checkout.qr.qr_expired")}</p>
            )}
          </div>
        </div>
        {!isQrExpired && payData?.expired && (
          <p className="checkoutCregis__container__countDown">
            <Trans
              i18nKey="checkout.qr.order_expire"
              components={[
                <CountDown
                  time={payData?.expired - Date.now()}
                  timeIsUpCallback={() => {
                    setIsQrExpired(true);
                  }}
                />,
              ]}
            />
          </p>
        )}
        <div className="checkoutCregis__container__details">
          <div>
            <p className="checkoutCregis__container__details__text">{t("checkout.qr.amount")}</p>
            <div style={{ display: "flex", alignItems: "center" }}>
              <p className="checkoutCregis__container__details__value">{`${payData.crypto_amount} ${payData.crypto_currency}`}</p>
              <CopyButton text={payData.crypto_amount} onlyIcon minWidth={20} height={20} />
            </div>
          </div>
          <div>
            <p className="checkoutCregis__container__details__text">{t("checkout.qr.network")}</p>
            <p className="checkoutCregis__container__details__value">{payData.crypto_address}</p>
          </div>
          {!isQrExpired && (
            <div>
              <p className="checkoutCregis__container__details__text">{t("checkout.qr.address")}</p>
              <div style={{ display: "flex", alignItems: "center" }}>
                <p className="checkoutCregis__container__details__value">{payData.qr_code}</p>
                <CopyButton text={payData.qr_code} onlyIcon minWidth={20} height={20} />
              </div>
            </div>
          )}
        </div>
        <div style={{ marginTop: "10px" }}>
          <Warning>
            <p className="">{t("checkout.qr.notice")}</p>
          </Warning>
        </div>
      </div>
    </div>
  );
}

export default CheckoutCregis;
